<div class="boxes-area boxes-style-two bg-f5f7fa" id='kttv'>
  <div class="container">
    <div class="row pt-5 pb-5">
      <div #mapRef style="width:100%;height:750px"></div>
    </div>
  </div>
</div>

<!--
<div style="height: 800px;" leaflet [leafletOptions]="options" (leafletMapReady)="onMapReady($event)">
</div> -->